<template>
  <div>
    <h1>
      <i class="bx bx-time-five"></i>
      Timeline Maker
    </h1>
  </div>
</template>

<script>
export default {
  name: "LogoHeader",
};
</script>

<style scoped>
h1 {
  margin: 10px 5px;
}
</style>
